import { useDispatch, useSelector } from "react-redux";
import { DisplayHonoraires } from "../../redux/actions/honnorairesActions";
import "./CommonsStyles.css";

const UserToggleHonoraires = () => {
  const dispatch = useDispatch();
  const isDisplayed = useSelector(
    (state) => state.displayHonorairesReducer.isDisplayed
  );

  return (
    <button
      title={`${isDisplayed ? "Masquer" : "Afficher"} les honoraires`}
      onClick={() => dispatch(DisplayHonoraires())}
      className="honorairesBtn"
    >
      <img
        src={
          isDisplayed
            ? "./icons/showHonoraires.svg"
            : "./icons/hideHonoraires.svg"
        }
        alt=""
      />
    </button>
  );
};

export default UserToggleHonoraires;
